'use client';

import PerfBarChart, { type PerfBar } from './PerfBarChart';

const data: PerfBar[] = [
  { label: ['Generic', '(Eigen GEMM)'], value: 50, valueLabel: '50x', color: 'gray' },
  { label: ['Generic', '(inline GEMM)'], value: 201, valueLabel: '201x', color: 'gray' },
  { label: 'A2 fast path', value: 316, valueLabel: '316x', color: 'yellow' },
];

export default function A2RtfM5() {
  return (
    <PerfBarChart
      headerTitle="Desktop Inference Speed"
      headerDescription="How fast A2-Lite runs on a modern desktop CPU, and how much headroom is left for the rest of your signal chain."
      title="A2-Lite inference on Apple M5"
      subtitle="64-sample buffer at 48 kHz, Apple M5. Real-time factor is how many times faster than real time the model runs; higher is better."
      data={data}
      yAxisTitle="Real-time factor (higher = faster)"
      yMax={350}
    />
  );
}
